import { OutgoingCheckoutSessionDto } from 'api/dtos/events/checkout';
import { Card } from 'legacy/user/types';

export enum CheckoutSteps {
  TicketTiers = 'ticketTiers',
  TicketTiersAddon = 'ticketTiersAddon',
  Summary = 'summary',
  RequestScreening = 'requestScreening',
  PrePurchaseQuestions = 'prePurchaseQuestions',
  SuccessRequestApproval = 'successRequestApprovalStep',
  Waivers = 'waiversStep',
  Success = 'successStep'
}

export const DEFAULT_TICKET_QUANTITY = 1;

export type TicketMetadata = {
  quantity: number;
};

export type NormalizedTickets = Record<string, TicketMetadata>;

export type GoToStepFn = (step: CheckoutSteps) => void;

export enum QuantityChangeEvents {
  Decrease = 'Decrease',
  Increase = 'Increase'
}

export type ToggleTicketTierFn = (
  toggledTicketId: string,
  callback?: (tickets: NormalizedTickets) => Promise<MultiTierCheckoutSession>
) => void;

export type UpdateQuantityFn = (
  ticketId: string,
  updateEvent: QuantityChangeEvents,
  callback?: (tickets: NormalizedTickets) => Promise<MultiTierCheckoutSession>
) => void;

export interface MultiTierCheckoutSession extends OutgoingCheckoutSessionDto {
  card: string;
}

export type LegacyCheckoutUpdateDataToSend = {
  ticketTiers: Record<string, { quantity: number }>;
  card: string;
  discountCode: string;
  promoterCode: string;
  discountCodeType?: string;
  privateTierCodes: Record<string, string>;
  stripePaymentMethodType?: 'klarna' | 'affirm';
};

export type UpdateCheckoutFn = (
  updateData: LegacyCheckoutUpdateDataToSend,
  cards?: Card[]
) => Promise<MultiTierCheckoutSession>;

export type CheckoutUpdateDataToSend = {
  ticketTiers: Record<string, { quantity: number }>;
  stripePaymentMethodId: string;
  stripePaymentMethodType: 'klarna' | 'affirm';
  discountCode: string;
  privateTierCodes: Record<string, string>;
  promoterCode?: string;
  trackingId?: string;
};
